const API_BASE_URL = 'https://api.realitni-jestrab.cz'

// Token storage key (same as authService)
const ACCESS_TOKEN_KEY = 'realitni_access_token'

export const listingService = {
  // Get all listings for the current user
  async getListings(page = 1, limit = 20, search = '') {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })

    if (search) {
      params.append('search', search)
    }

    const response = await fetch(`${API_BASE_URL}/api/listings?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
    })

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.response = response
      throw error
    }

    return await response.json()
  },

  // Get a specific listing by ID
  async getListing(id) {
    const response = await fetch(`${API_BASE_URL}/api/listings/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
    })

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.response = response
      throw error
    }

    return await response.json()
  },

  // Create a new listing
  async createListing(listingData) {
    const response = await fetch(`${API_BASE_URL}/api/listings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
      body: JSON.stringify(listingData),
    })

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.response = response
      throw error
    }

    return await response.json()
  },

  // Update an existing listing
  async updateListing(id, listingData) {
    const response = await fetch(`${API_BASE_URL}/api/listings/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
      body: JSON.stringify(listingData),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  },

  // Delete a listing
  async deleteListing(id) {
    const response = await fetch(`${API_BASE_URL}/api/listings/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN_KEY)}`,
      },
    })

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.response = response
      throw error
    }

    return true
  },
}
